import { render, staticRenderFns } from "./PopupNotifications.vue?vue&type=template&id=be03f8be&scoped=true"
import script from "./PopupNotifications.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupNotifications.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PopupNotifications.vue?vue&type=style&index=0&id=be03f8be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be03f8be",
  null
  
)

export default component.exports